module.exports = __webpack_public_path__ + "img/hr-V-R-4-unload-standup-shadow.5cfb7ac6.png";